import { ComponentProps, FC } from 'react';
import { useTranslation } from 'next-i18next';
import { BannerBox } from '../../box/BannerBox';
import { VariationIcon } from '../VariationIcon/VariationIcon';

export const ConversionVeryOverPriceBanner: FC<ComponentProps<typeof BannerBox>> = ({ ...props }) => {
  const { t } = useTranslation('price-drop');

  return (
    <BannerBox
      variant="danger"
      title={t('PRICE_DROP.PRICE_ZONE.CONVERSION.VERY_OVER_PRICE.TITLE')}
      titleIcon={<VariationIcon name={'high-warning'} />}
      description={t('PRICE_DROP.PRICE_ZONE.CONVERSION.VERY_OVER_PRICE.INFO')}
      showLearnMoreButton={true}
      {...props}
    />
  );
};
